import React from "react";

import styles from "./AccessibilityMatrix.module.scss";

interface AccessibilityIconProps {
  icon: React.ReactNode;
  label?: string;
  ariaDescribedBy: string;
  id?: string;
}

export const AccessibilityIcon: React.FC<AccessibilityIconProps> = ({
  icon,
  label,
  // ariaDescribedBy,
  // id,
}) => (
  <div className={styles["section__icon"]}>
    <div className={styles["section__icon__image"]}>{icon}</div>
    {label && (
      <span aria-label={"Permanent"}>
        <div
          // id={id}
          // aria-labelledby={ariaDescribedBy}
          className={styles["section__icon__label"]}
        >
          {label}
        </div>
      </span>
    )}
  </div>
);
